import { SliceInputType } from '@/services/MerchandisingCollectionsService';

export function sliceInputText(inputType: SliceInputType) {
  const sliceInputMap: Partial<Record<SliceInputType, string>> = {
    [SliceInputType.AUDIENCE]: 'BEHAVIOR',
  };

  return sliceInputMap[inputType] ?? inputType;
}
